import { loadingEndedAction, loadingStartedAction } from "../isLoading/actions";
import axiosInstance from '../../utils/axiosInstance';
import { loadItemRequestDetailAction, removeItemRequestDetailAction } from "./actions";

export const loadItemRequestDetail = (id) => (dispatch) => {
    dispatch(loadingStartedAction());
    const uri = `/api/item_requests/${id}`;
    axiosInstance.get(uri).then((res) => {
      if (res.status === 200) {
        dispatch(loadItemRequestDetailAction(res.data));
        dispatch(loadingEndedAction());
      }
      dispatch(loadingEndedAction());
    });
  };

  export const removeItemRequestDetail = () => (dispatch)=>{
       dispatch(removeItemRequestDetailAction());
  }